import {defineStore} from 'pinia'
import type {AdminDrawerCount} from "~/types/admin/theme";
import type {AdminDrawerData} from "~/types/admin/drawer";
import {useI18n} from "vue-i18n";

export const useAdminDrawerStore = defineStore('adminDrawerStore', () => {
    const runtimeConfig = useRuntimeConfig()
    const decathStore = useDecathlonStores()
    const adminDrawerData = ref<AdminDrawerData>()
    const {t} = useI18n()
    const fetchAdminDrawerData = async () => {
        if (!decathStore.selectedCrossDiag) return
        const result = await useFetchWithToken<AdminDrawerCount>('fetchAdminDrawerData',
            `${runtimeConfig.public.apiBase}/v1/admin/drawer-data?storeId=${decathStore.selectedStore!.id}&diagnosticId=${decathStore.selectedCrossDiag?.id}`, {
                method: 'get',
            })
        if (result) {
            adminDrawerData.value = {
                themes: {
                    id: 'themes',
                    label: t('themes'),
                    enabledCount: result.enabledThemeCount,
                    disabledCount: result.disabledThemeCount,
                    archivedCount: result.archivedThemeCount,
                    url: `/admin/themes`
                },
                subThemes: {
                    id: 'subThemes',
                    label: t('subThemes'),
                    enabledCount: result.enabledSubThemeCount,
                    disabledCount: result.disabledSubThemeCount,
                    archivedCount: result.archivedSubThemeCount,
                    url: `/admin/subThemes`
                },
                questions: {
                    id: 'questions',
                    label: t('questions'),
                    enabledCount: result.enabledQuestionCount,
                    disabledCount: result.disabledQuestionCount,
                    archivedCount: result.archivedQuestionCount,
                    url: `/admin/questions`
                },
            }
            return adminDrawerData
        }
    }

    const resetAdminDrawerData = async () => {
        adminDrawerData.value = {
            themes: {
                id: 'themes',
                label: t('themes'),
                enabledCount: 0,
                disabledCount: 0,
                archivedCount: 0,
                url: `/admin/themes`
            },
            subThemes: {
                id: 'subThemes',
                label: t('subThemes'),
                enabledCount: 0,
                disabledCount: 0,
                archivedCount: 0,
                url: `/admin/subThemes`
            },
            questions: {
                id: 'questions',
                label: t('questions'),
                enabledCount: 0,
                disabledCount: 0,
                archivedCount: 0,
                url: `/admin/questions`
            },
        }
        return adminDrawerData
    }


    return {
        fetchAdminDrawerData,
        resetAdminDrawerData,
        adminDrawerData
    }
})
